<template>
    <card class='novo-emprestimo' title='Novo Empréstimo'>
        <form @submit.prevent.stop='areYouSure()'>
            <div class='row'>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Membro</label>
                        <multiselect @remove='update' @input='update' track-by='id' label='name' v-model="emprestimo.membro" :options="membros" :allow-empty="false"></multiselect>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Obra</label>
                        <multiselect @remove='update' @input='update' track-by='id' label='name' v-model="emprestimo.obra" :options="obras" :allow-empty="false"></multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Semanas</label>
                        <input class='form-control border-input' type="number" v-model="emprestimo.weeks">
                    </div>
                </div>
                <div class='col-md-2'>
                  <div class='form-group'>
                    <label for="">Notificar por Email</label>
                    <button class='btn btn-success btn-block' @click.prevent.stop='toggleNotificacao()' v-if='emprestimo.enviar_notificacoes'>Sim</button>
                    <button class='btn btn-danger btn-block' @click.prevent.stop='toggleNotificacao()' v-else>Não</button>
                  </div>
                </div>
            </div>
            <div class='row'>
                <div class="col-md-4" >
                    <div class="form-group">
                        <button v-if='!emprestimo.nao_membro' @click.prevent='toggleMembro()' class='btn btn-warning btn-block'>Emprestar Para Não Membro</button>
                        <button v-else class='btn btn-success btn-block' @click.prevent='toggleMembro()'>Emprestar Para Membro</button>
                    </div>
                    <div class="form-group" v-if='emprestimo.nao_membro'>
                        <label>Observação</label>
                        <input class='form-control border-input' type="text" v-model="emprestimo.observacao">
                    </div>
                </div>
            </div>
            <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill btn-wd">Salvar</button>
            </div>
        </form>
    </card>
</template>
<script>

import Multiselect from 'vue-multiselect'

import EmprestimoService from '../../services/emprestimo-service'
import OverlayService from '../../services/overlay-service'

import { mapState } from 'vuex'

export default {
  components: {
    Multiselect
  },

  computed: {
    ...mapState(['membros', 'obras']),
  },

  data () {
    return {
      emprestimo: this.clearEmprestimo()
    }
  },

  mounted () {
    
  },

  methods: {

    clearEmprestimo () {
      return {
        nao_membro: false,
        enviar_notificacoes: true
      }
    },

    toggleNotificacao () {
      this.emprestimo.enviar_notificacoes = !this.emprestimo.enviar_notificacoes
    },

    toggleMembro () {
      this.emprestimo.nao_membro = !this.emprestimo.nao_membro
    },

    areYouSure () {
      this.$alertify.confirmWithTitle('Confira os Valores:', `<ul><li><strong>Membro: ${this.emprestimo.membro.nome} ${this.emprestimo.membro.sobrenome}</strong></li><li>Obra: ${this.emprestimo.obra.titulo}</li></ul>`, () =>
        this.submit()
        , () => {}
      )
    },

    submit () {
      const toSave = JSON.parse(JSON.stringify(this.emprestimo))

      if (!toSave.obra) {
        this.$alertify.error('Selecione a Obra')
        return
      }

      if (!toSave.membro) {
        this.$alertify.error('Selecione o Membro')
        return
      }

      toSave.nao_membro = toSave.nao_membro ? 1 : 0
      toSave.obra_id = toSave.obra.id
      toSave.emprestado_para = toSave.membro.id
      delete toSave.membro
      delete toSave.obra

      OverlayService.trigger('show', true)

      EmprestimoService.novo(toSave)
        .then(emprestimo => emprestimo.data)
        .then(emprestimo => {
          OverlayService.trigger('show', false)
          this.$alertify.success('Empréstimo Criado Com Sucesso!')

          this.emprestimo = this.clearEmprestimo()
          this.$emit('new')
        }).catch(er => {
          let message = 'Erro ao criar empréstimo'

          if (er.response.data.message) {
            message = this.$t(er.response.data.message)
          }
          this.$alertify.error(message)
          OverlayService.trigger('show', false)
        })
    },

    update () {
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped>
.novo-emprestimo {
  z-index: 2;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

